import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { IDeps, TProps } from './models';
import { Img as Component } from './img';
import styles from './styles/styles.css';

// className прокидывается на корневой элемент через переменную classNames
// eslint-disable-next-line styler/check-styler
export const ImgV2 = createWidget<IDeps, TProps>({ styles }, { priorityStyler: true })(Component);
